import React from 'react'
import { useTranslation } from 'react-i18next'

import { notEmpty } from 'helpers/validators'
import ContentBlock from 'components/ContentBlock'
import { Form, Text } from 'components/forms'
import ClientSelector from 'components/forms/ClientSelector'

const Region = ({ formData, mutations: { updateItem } }) => {
	const [t] = useTranslation()

	return(
		<ContentBlock>
			<Form
				smartSubmit
				initialValues={formData}
				onSubmit={updateItem}
			>
				<ClientSelector lastNode='DEPARTMENT' field='departmentId' {...notEmpty()} />
				<Text field='name' label={t('options_section.fields.region_name')} {...notEmpty()} />
			</Form>
		</ContentBlock>
	)
}

export default Region
